import { AxiosError } from 'axios';
import {ERROR_CODE_MESSAGE, DEFAULT_ERROR_MESSAGE_CODE} from '../errorCode';
import { ApiErrorData } from '../service';

export const getErrorMessage = (errorData: ApiErrorData, usingServerMessage: boolean) => {
  const ErrorResult = Array.isArray(errorData.result) ? errorData.result[0]: errorData.result;

  if(!ErrorResult || !ErrorResult.errorCode) return ERROR_CODE_MESSAGE[DEFAULT_ERROR_MESSAGE_CODE];

  let errorMessage: string;
  // 서버 메시지 사용
  if(usingServerMessage && ErrorResult.displayableMessage){
    if(ErrorResult.message){
      errorMessage = ErrorResult.message;
    }else{
      errorMessage = ERROR_CODE_MESSAGE[DEFAULT_ERROR_MESSAGE_CODE];
    }
  // 서버 메시지 사용 안함
  }else {
    const code = Object.keys(ERROR_CODE_MESSAGE).includes(ErrorResult.errorCode) && ErrorResult.errorCode ||  DEFAULT_ERROR_MESSAGE_CODE;
    errorMessage = ERROR_CODE_MESSAGE[code];
  }

  return errorMessage;
};


export const displayErrorMessage = (error: AxiosError<ApiErrorData>) =>{
  const errorData = (error).response?.data;
  if(!errorData) return false;

  // [TODO] usingServeMessage => false 바꾸기
  const errorMessage = getErrorMessage(errorData, false);
  window.alert(errorMessage);
  return true;
};





